import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IGeneralSettings} from "../../models/GeneralSettings";


interface IInitialState {
    generalSettingsLoading: boolean;
    generalSettings: IGeneralSettings;
}

const initialState: IInitialState = {
    generalSettingsLoading: true,
    generalSettings: {
        id: 0,
        defaultLanguage: "",
        faviconPath: "",
        seoTag1: "",
        seoTag2: "",
        logoPath: ""
    }
}

const generaContentSettingsSlice = createSlice({
    name: "GeneraContentSettingsSlice",
    initialState,
    reducers: {
        setGeneralSettings: (state, action: PayloadAction<IGeneralSettings>) => {
            state.generalSettingsLoading = false;
            state.generalSettings = action.payload;
        }
    }
})

export const {setGeneralSettings} = generaContentSettingsSlice.actions;

export default generaContentSettingsSlice.reducer;